<h1 class="page-title">Missziók</h1>

<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok/bab']">Báb csapat</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok/pantomim']">Pantomim</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok/plantalt']">Plántált gyülekezeteink</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/missziok/misszionariusok']">Misszionáriusaink</a></p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/missions/missions.component.html